import { render, staticRenderFns } from "./MocktestRanks.vue?vue&type=template&id=f08e834c&"
import script from "./MocktestRanks.vue?vue&type=script&lang=js&"
export * from "./MocktestRanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports